// hooks/usePromotionFilters.js
import { useState, useEffect, useMemo } from 'react';
import promotionService from '../services/PromotionService';

const usePromotionFilters = (allPromotions = [], onFilterChange) => {
  const [filters, setFilters] = useState({
    category: 'Welcome Bonus',
    searchQuery: '',
    brandId: null
  });

  // Filtered promotions based on current filters
  const filteredPromotions = useMemo(() => {
    if (!allPromotions.length) return [];
    
    return promotionService.filterPromotions(allPromotions, filters);
  }, [allPromotions, filters]);

  // Update category filter
  const updateCategory = (category) => {
    setFilters(prev => ({
      ...prev,
      category
    }));
  };

  // Update search query filter
  const updateSearchQuery = (query) => {
    setFilters(prev => ({
      ...prev,
      searchQuery: query
    }));
  };

  // Update brand filter
  const updateBrandId = (brandId) => {
    setFilters(prev => ({
      ...prev,
      brandId
    }));
  };

  // Clear all filters
  const clearFilters = () => {
    setFilters({
      category: 'All',
      searchQuery: '',
      brandId: null
    });
  };

  // Reset filters to default (Welcome Bonus)
  const resetFilters = () => {
    setFilters({
      category: 'Welcome Bonus',
      searchQuery: '',
      brandId: null
    });
  };

  // Check if any filters are active (always true when filtering by category or search)
  const hasActiveFilters = useMemo(() => {
    return filters.category !== 'All' ||
           filters.searchQuery !== '' ||
           filters.brandId !== null;
  }, [filters]);

  // Notify parent component when filters change
  useEffect(() => {
    if (onFilterChange) {
      onFilterChange(filteredPromotions, filters);
    }
  }, [filteredPromotions, filters, onFilterChange]);

  return {
    // Current filters
    filters,
    
    // Filtered data
    filteredPromotions,
    
    // Filter actions
    updateCategory,
    updateSearchQuery,
    updateBrandId,
    clearFilters,
    resetFilters,
    
    // Computed values
    hasActiveFilters,
    filteredCount: filteredPromotions.length,
    totalCount: allPromotions.length
  };
};

export default usePromotionFilters;